// extracted by mini-css-extract-plugin
export default {"signin":"style_signin__jL6jQ","forgot":"style_forgot__vofHk","btnHolder":"style_btnHolder__PrZeh"};